<script>
  let width = 0;
  let height = 0;

</script>


<div class="continer" bind:offsetWidth="{width}" bind:offsetHeight="{height}">
  <svg viewBox="0 0 {width} {height}" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
    <symbol id="bird" viewBox="0 0 768 768">
      <path fill="#fff" d="M667 569c-13 15 29 39 39 38 16-1 21-21 15-29-4-4-44-22-54-9zM529 642c-11 6 3 40 19 49 20 12 70 0 68-13-4-24-69-48-87-36zM52 80c13 25 51 50 48 93-10 111-22 325 51 393 0 0 12-87 40-89 52-3 138 95 290 46 141-45 132-220 132-220 62-55 134-116 125-153-12-47-210 8-313-21-107-30-166-92-229-98-58-5-116 22-144 49zm255 328c58 37 106 48 142 34s59-53 67-115c-61 57-142 70-209 81zm-91-298c19 9 28 30 21 46-8 17-30 23-49 14s-29-29-21-46c7-16 29-23 49-14z"/>
    </symbol>

    <!-- <use xlink:href="#bird" x="50" y="50" height="300" width="300" class="color1" /> -->

    <pattern id="PatternB" x="-50" y="-50" width="300" height="300" patternUnits="userSpaceOnUse">
      <use xlink:href="#bird" height="100" width="100" class="color1" />
      <use xlink:href="#bird" height="100" width="100" x="150" y="150" class="color1" />
    </pattern>
    <rect fill="url(#PatternB)" width="{width}" height="{height}"/>
  </svg>
</div>

<style>
  .continer {
    width: 100%;
    height: 100%;
    background-color: rgb(255, 173, 21);
  }
</style>
